import {applyMiddleware, createStore} from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducer, {reducerPreloadedState} from './reducer';
import {watchPresentationSaga} from './sagas/presentation';
import {watchSlideSaga} from './sagas/slide';
import {undoRedoMiddleware} from './middleware/undoRedoMiddleware';

const sagaMiddleware = createSagaMiddleware();

export const store = createStore(reducer, reducerPreloadedState, applyMiddleware(sagaMiddleware, undoRedoMiddleware));
sagaMiddleware.run(watchPresentationSaga);
sagaMiddleware.run(watchSlideSaga);
